module.exports = __webpack_public_path__ + "img/nakamoto-coefficient.4e48f645.png";